import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5812631e")

_pushScopeId("data-v-5812631e")
const _hoisted_1 = { class: "absolute top-0 bottom-0 left-0 right-0 grid" }
const _hoisted_2 = {
  key: 0,
  class: "flex pt-4 bg-primary-dark"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "text-5xl" }, "‹", -1)
const _hoisted_4 = { class: "flex items-center justify-center overflow-x-auto text-2xl" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "text-5xl" }, "›", -1)
const _hoisted_6 = { class: "flex pt-4 border-b shadow-lg bg-primary-dark" }
const _hoisted_7 = { class: "flex-shrink-0 px-4 w-96" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col flex-shrink-0 p-2 border whitespace-nowrap bg-primary-dark"
}
const _hoisted_9 = { class: "w-full overflow-hidden overflow-y-scroll" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "flex flex-col flex-shrink-0 w-96" }
const _hoisted_12 = { class: "flex items-center h-10 text-sm whitespace-nowrap" }
const _hoisted_13 = { class: "px-4" }
const _hoisted_14 = {
  ref: "gridContainer",
  class: "w-full"
}
const _hoisted_15 = { class: "flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_grid_grade_selector = _resolveComponent("grid-grade-selector")
  const _component_icon_component = _resolveComponent("icon-component")

  return (_openBlock(), _createBlock("div", {
    class: "relative w-full h-full focus:outline-none",
    onKeypress: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleKeyPress && _ctx.handleKeyPress(...args))),
    tabindex: "0"
  }, [
    _createVNode("section", _hoisted_1, [
      (_ctx.pages > 1)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("button", {
              class: ["mr-2 ml-96 focus:outline-none", { 'opacity-20': _ctx.isFirstPage }],
              disabled: _ctx.isFirstPage,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePaginationPrevious && _ctx.handlePaginationPrevious(...args)))
            }, [
              _hoisted_3
            ], 10, ["disabled"]),
            _createVNode("div", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pages, (page, index) => {
                return (_openBlock(), _createBlock("button", {
                  key: index,
                  onClick: ($event: any) => (_ctx.handlePaginationPageClick(index)),
                  class: ["px-1 mx-1 font-bold border-b-2 border-transparent focus:outline-none", {
              'border-white': _ctx.paginationIndex === index
            }]
                }, _toDisplayString(page), 11, ["onClick"]))
              }), 128))
            ]),
            _createVNode("button", {
              class: ["ml-2 focus:outline-none", { 'opacity-20': _ctx.isLastPage }],
              disabled: _ctx.isLastPage,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handlePaginationNext && _ctx.handlePaginationNext(...args)))
            }, [
              _hoisted_5
            ], 10, ["disabled"])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          (!_ctx.readonly)
            ? (_openBlock(), _createBlock(_component_grid_grade_selector, {
                key: 0,
                onGradeSelected: _ctx.handleGradeSelection,
                onClearSelection: _ctx.clearSelections,
                numSelected: _ctx.selectedGridCells.length + _ctx.selectedEvents.length
              }, null, 8, ["onGradeSelected", "onClearSelection", "numSelected"]))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.headerData, (event, columnIndex) => {
          return (_openBlock(), _createBlock("div", { key: columnIndex }, [
            _createVNode("div", {
              class: ["flex flex-col items-center flex-shrink-0 w-10 border whitespace-nowrap bg-primary-dark", {
              'animate-pulse': event.loading
            }]
            }, [
              (!_ctx.readonly)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "flex items-center justify-center w-4 h-4 mt-4 bg-red-500 rounded ext-xs focus:outline-none",
                    onClick: ($event: any) => (_ctx.handleColumnDeleteClick(event, columnIndex)),
                    "data-testid": `column-delete-${columnIndex}`,
                    disabled: event.loading
                  }, " ✕ ", 8, ["onClick", "data-testid", "disabled"]))
                : _createCommentVNode("", true),
              _createVNode("button", {
                class: "my-4 text-center small-text focus:outline-none",
                "data-testid": `event-details-${event.name}`,
                onClick: ($event: any) => (_ctx.handleEventNameClick(event)),
                disabled: event.loading
              }, _toDisplayString(event.name), 9, ["data-testid", "onClick", "disabled"]),
              _createVNode("span", {
                class: "mt-auto mb-2 text-xs text-center text-gray-500",
                innerHTML: _ctx.formatDate(event.date)
              }, null, 8, ["innerHTML"]),
              _createVNode("button", {
                class: ["flex items-center justify-center w-10 h-10 mb-2 cursor-default focus:outline-none", {
                'cursor-pointer': !_ctx.readonly,
                'active-grid-cell': _ctx.eventIsActive(event),
                'selected-grid-cell':
                  _ctx.selectedEvent && _ctx.selectedEvent.id === event.id
              }],
                "data-testid": `event-overall-grade-${event.name}`,
                onClick: ($event: any) => (_ctx.handleEventClick(event)),
                onDblclick: ($event: any) => (_ctx.handleEventDoubleClick(event)),
                disabled: _ctx.readonly || event.loading
              }, [
                _createVNode(_component_icon_component, {
                  icon: _ctx.GradeIconMap.get(event.overallGrade)
                }, null, 8, ["icon"])
              ], 42, ["data-testid", "onClick", "onDblclick", "disabled"]),
              (!_ctx.readonly)
                ? (_openBlock(), _createBlock("input", {
                    key: 1,
                    type: "checkbox",
                    class: "mb-2 text-2xl text-center font-extralight focus:outline-none",
                    onChange: ($event: any) => (_ctx.handleSelectEventCells($event.target.checked, event)),
                    "data-testid": `event-grid-checkbox-${columnIndex}`,
                    disabled: event.loading
                  }, null, 40, ["onChange", "data-testid", "disabled"]))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        }), 128)),
        (_ctx.isLastPage && !_ctx.readonly)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode("button", {
                class: "flex items-center justify-center py-2 mt-auto mb-2 text-xs bg-blue-500 rounded focus:outline-none",
                disabled: !_ctx.selectedNextEvent,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleCreateEvent && _ctx.handleCreateEvent(...args))),
                "data-testid": "add-event-button"
              }, " Add + ", 8, ["disabled"]),
              _withDirectives(_createVNode("select", {
                class: "p-2 py-1 text-xs border rounded focus:outline-none",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedNextEvent = $event)),
                "data-testid": "add-event-select"
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.unlockedEvents, (event, index) => {
                  return (_openBlock(), _createBlock("option", {
                    class: "text-xs",
                    value: event,
                    key: index
                  }, _toDisplayString(event.name), 9, ["value"]))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedNextEvent]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.maneuvers, (maneuver, rowIndex) => {
              return (_openBlock(), _createBlock("div", { key: rowIndex }, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("span", _hoisted_13, _toDisplayString(maneuver.maneuver), 1)
                ])
              ]))
            }), 128))
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.eventGrid, (eventGridRow, eventGridRowIndex) => {
                return (_openBlock(), _createBlock("div", { key: eventGridRowIndex }, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(eventGridRow, (eventGridCell) => {
                    return (_openBlock(), _createBlock("button", {
                      class: ["flex items-center justify-center flex-shrink-0 w-10 h-10 border cursor-default whitespace-nowrap bg-primary-dark focus:outline-none", {
                    'animate-pulse':
                      eventGridCell.event.loading ||
                      eventGridCell.maneuver.loading,
                    'cursor-pointer':
                      !_ctx.readonly && eventGridCell.maneuver.editable,
                    'active-grid-cell': _ctx.gridCellIsActive(eventGridCell),
                    'selected-grid-cell':
                      _ctx.selectedGridCell &&
                      _ctx.selectedGridCell.cellId === eventGridCell.cellId
                  }],
                      "data-testid": `${eventGridCell.event.name}-${eventGridCell.maneuver.name}`,
                      disabled: 
                    _ctx.readonly ||
                    eventGridCell.event.loading ||
                    eventGridCell.maneuver.loading
                  ,
                      onClick: ($event: any) => (_ctx.handleGridItemClick($event, eventGridCell)),
                      onDblclick: ($event: any) => (_ctx.handleGridItemDoubleClick(eventGridCell)),
                      key: eventGridCell.cellId
                    }, [
                      (
                      eventGridCell.maneuver.icon &&
                      eventGridCell.maneuver.editable
                    )
                        ? (_openBlock(), _createBlock(_component_icon_component, {
                            key: 0,
                            icon: eventGridCell.maneuver.icon
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true)
                    ], 42, ["data-testid", "disabled", "onClick", "onDblclick"]))
                  }), 128))
                ]))
              }), 128))
            ])
          ], 512)
        ])
      ])
    ])
  ], 32))
})